const kr = {
  10000001: 'SuperEx 2주년 축하',
  10000002: '로그인하시면 푸짐한 보상을 받으실 수 있습니다',
  10000003: '참가자 수에 따라 최대 10,000USDT의 상금이 주어지며, 참가자 수가 많을수록 상금의 규모도 커집니다. ',
  10000004: 'SuperEx 두 주년 기념',
  10000005: '선물 거래 대회에서 20,000 USDT를 획득하다',
  10000006: `선물 거래량 순위 경쟁을 통해 최대 <span style="color: #ffc72b;">10,000</span> USDT의 보너스 풀을 잠금 해제하세요`,
  10000007: '퓨처스 챔피언십',
  10000008: '선물 거래 대회에서 20,000 USDT를 획득하다',

  10000009: '선택하세요',
  10000010: '발행 총량',
  10000011: '블루체인 검색',
  10000012: '뒤로 돌아가기',
  10000013: '다음',
  10000014: '뒤로 돌아가기',
  10000015: '정보를 입력해주세요.',
  10000016: '토큰 이름을 입력하세요',
  10000017: '통화의 전체 이름을 입력하세요',
  10000018: '알겠습니다',
  10000019: '부제목 이름을 입력하세요',
  10000020: '화폐 유통량을 입력하세요',
  10000021: '완료',
  10000022: '이후, 해당 거래 쌍의 통계 데이터는 웹사이트의 Free Market 페이지에서 확인할 수 있습니다.',
  10000023: '{currency} 상장됨!',
  10000024: '년',
  10000025: '월',
  10000026: '일',

  8000067: '데이터 통계',
  8000068: '토큰 이름',
  8000069: '메인 체인 또는 프로토콜',
  8000070: '계약 주소 또는 TICKER',
  8000071: '부제목',
  8000072: '복제 생성 시간',
  8000073: '복제 상태',
  8000074: '누적 배당액/U',
  8000075: '지난 주 배당액/U',
  8000076: '지난 주 거래액/U',
  8000077: '지난 주 거래 횟수',
  8000078: '거래쌍 생성하기',
  8000079: '연기',
  8000080: '이미 상장됨',
  8000081: '곧 상장 종료 예정',
  8000082: '상장 종료됨',
  8000083: '통화 확인',
  8000084: '코인 상장 안내',
  8000085: '성공',
  8000086: '자유구 상장',
  8000087: 'SuperEx에서는 손쉽고 무료로 거래소 상장을 완료할 수 있으며, 최대 80%의 거래 수수료 배당 기회가 제공됩니다.',
  8000088: '코인을 상장하는 방법?',
  8000089: '새 거래 페어 만들기',
  8000090: '저는 코인을 상장할 거예요',
  8000091: '거래 페어 복제 생성하기',
  8000092: 'SuperEx 거래소',
  8000093: '우리를 선택하는 이유는 무엇인가요?',
  8000094: '다양한 선택지',
  8000095: '다중 체인 및 프로토콜을 지원합니다. BSC 체인, ETH 체인, SOL 체인을 포함합니다.',
  8000096: '인간의 검토 없이 즉시 상장할 수 있으며, 분산형 상장 절차와 주문서에서 주문하는 편의성을 경험할 수 있습니다.',
  8000097: 'API를 지원합니다',
  8000098: 'API 인터페이스를 사용하여 시장 조성 및 거래를 수행함으로써 작업을 보다 효율적이고 자동화할 수 있습니다.',
  8000099: '플랫폼 노출',
  8000100: '현물 자유 구역에 상장하여 SuperEx의 수백만 사용자 트래픽을 누리고 더 많은 관심을 받을 수 있습니다.',
  8000101: '초보자이든 경험 많은 트레이더이든, 저희의 현물 프리 존은 새로운 경험과 투자 기회를 제공할 것입니다. 지금 바로 본인만의 거래 쌍을 생성하고, 마음에 드는 미미코인을 홍보하며 거래 수수료의 분배 수익을 즐기세요!',
  8000102: '거래 쌍을 생성하려면 총 자산이 {resultData}U 이상이어야 합니다.',
  8000103: '거래소',
  8000104: '원하는 암호화폐를 선택하고 USDT와 조합하여 거래 쌍을 만들어 독특한 거래 상품을 생성할 수 있습니다.',
  8000105: '수수료 배당을 받다',
  8000106: '거래 쌍 복제본의 거래 금액이 일정 임계값에 도달하면 일부 거래 수수료가 분배되어 돌아옵니다. 이렇게 하면 거래 쌍 복제본을 생성한 당신도 거래 수익을 공유할 수 있습니다.',
  8000107: '현재 제한된 사용자로 인해 새로운 거래 쌍을 생성할 수 없습니다. 내일 다시 시도해주세요.',
  8000108: '언어를 선택하세요',
  8000109: '백지',
  8000110: '해당 코인은 상장이 금지되었습니다!',
  8000111: '해당 코인은 이미 SuperEx 메인 보드 거래 구역에 존재하므로, 더 이상 거래 쌍을 생성할 수 없습니다!',
  8000112: '유효한 계약 주소/티커를 입력하세요.',
  8000113: '당신의 현물 주요 보드의 ET 잔액이 부족하여 새 거래 쌍을 생성하기 위해서는 {num}ET의 관리 비용을 지불해야 합니다. 충전 후 다시 시도하세요.',
  8000114: '오늘 신규 코인 생성 중 잘못된 입력 횟수가 너무 많아 오늘은 새로운 코인 생성 신청을 할 수 없습니다. 내일 다시 시도해주세요.',
  8000115: '해당 코인은 이미 존재하므로, 지금은 귀하의 거래 쌍 복제본을 생성합니다!',
  8000116: '아래는 확인해야 할 정보입니다:',
  8000117: '코인의 소수 자릿수 길이',
  8000118: '자유롭게 코인을 상장하는 방법',
  8000119: '통화의 전체 이름',
  8000120: '화폐 가격의 소수 자릿수 길이',
  8000121: 'SUPEREX 코인 상장: <em class="normal" style="color: #0CAA6D;">상장 수수료 0원! </em><em class="normal" style="color: #1D90F5;">소통 비용 0원! </em> 1분 안에 거래소 상장을 완료하고, 최대 <em class="normal" style="color: #F65D62;">80%의 수익 배당</em> 을 누리세요.',
  8000122: '영문 화폐 소개',
  8000123: '필수 입력 정보:',
  8000124: '입력한 부제 이름이 이미 존재합니다. 다시 입력해주세요!',
  8000125: '다음은 선택 사항입니다:',
  8000126: '주 체인 또는 프로토콜과 해당 관리 수수료를 선택하세요.',
  8000127: '첫 번째 단계: 새 코인의 계약 주소를 복사하여 붙여넣기.',
  8000128: '계약 주소/티커를 입력해주세요.',
  8000129: '생성을 확인합니다',
  8000130: '거래 쌍 복사본 {currency} 이 성공적으로 생성되었습니다!',
  8000131: '두 번째 단계: 해당 코인이 처음으로 거래소에 상장되는 경우, 코인 소개 및 로고 이미지 업로드와 같은 몇 가지 기본 정보를 추가해야 합니다.',
  8000132: 'BTC 프로토콜 시장',
  8000133: '세 번째 단계: 생성한 이 거래 쌍 복제본에 이름을 지정하면 됩니다. 그러면 상장 절차가 완료되고 이 코인이 공개 거래 가능해집니다.',
  8000134: '자유 코인 상장',
  8000135: '총 발행량을 입력해주세요',
  8000136: '네 번째 단계: 복제본의 주간 거래액이 임계값에 도달하면 해당 복제본의 거래 수수료 수익을 받게 됩니다.',
  8000137: '2를 선택하면 통화 가격을 나타내는 숫자 값이 0.01 단위로 표시됩니다. 예를 들어 BTC 가격은 $72156.78로 표시됩니다. 대부분의 밈 코인의 경우 11을 선택하는 것이 좋습니다.',
  8000138: '입력해주세요',
  8000139: '저는 이제 코인 상장을 시작할 거예요',
  8000140: '영문으로 통화에 대한 간략한 소개를 입력하세요',
  8000141: '인스턴스는 동일한 거래 쌍에 여러 버전이 존재할 수 있다는 것을 의미하며, 그 중 하나가 당신이 만든 인스턴스입니다. 다른 사용자들은 인스턴스 이름으로 이러한 버전들을 구별합니다. 사용자가 귀하의 인스턴스를 선택하여 거래를 진행하면, 관련된 거래 수수료 커미션을 받을 기회가 있습니다.',
  8000142: '이메일 형식이 올바르지 않습니다.',
  8000143: '블록 조회 주소',
  8000144: '화폐 유통량',
  8000145: '화폐 유통량은 1-20자리의 양의 정수로 제한됩니다',
  8000146: '화폐 종류 아이콘',
  8000147: 'PNG 또는 JPG 형식을 지원하며, 파일 크기는 5 MB 이내로 제한되며, 하루에 최대 10회 업로드할 수 있습니다.',
  8000148: '화폐 발행 시간',
  8000149: '발행 시간을 선택하세요',
  8000150: '백서 링크를 입력하세요',
  8000151: '공식 웹사이트',
  8000152: '공식 웹사이트 링크를 입력하세요',
  8000153: '현물 자유구 상장',
  8000154: '거래소에 당신의 토큰 상장 요청하기',
  8000155: '화폐 약어의 입력 제한은 9자리 문자이며, 숫자, 영어 알파벳 및 영어 기호만 지원됩니다',
  8000156: '화폐의 전체 이름 입력 제한은 50자리 문자이며, 숫자, 공백, 영어 알파벳 및 영어 기호만 지원됩니다',
  8000157: '발행 총량은 1-20 자리의 양의 정수로 제한됩니다',
  8000158: '여러 언어, 구두점, 숫자 및 공백을 지원하며, 시작 또는 끝 문자는 공백일 수 없고 연속된 공백은 허용되지 않습니다',
  8000159: '1. 상장 신청자는 정보의 진실성에 대해 스스로 책임을 져야하며, 플랫폼은 언제든지 토큰 또는 거래 쌍을 중단시킬 권리가 있으며, 정보 내용을 언제든지 조정할 수 있습니다.',
  8000160: '2. 상장 신청자는 상장 토큰에 대해 충분한 조사를 수행하고, 합리적이고 규정 준수 및 합법성을 보장해야 합니다. 플랫폼은 토큰의 스마트 계약이 악의적이거나 해로운 행위를 포함하는 경우 직접 토큰을 중단시키고, 사용자를 대신하여 상장 신청자에게 손해배상을 청구할 수 있습니다.',
  8000161: '3. 상장 신청자나 다른 사람이 향후에 토큰 정보를 조정하려는 경우, 저희 고객 서비스에 연락해야 합니다.',
  8000162: '4. 사용자의 이익을 보호하고 불량 통화를 제거하기 위해 등록된 사용자가 생성한 거래 쌍이 우리 플랫폼의 거래량 요구 사항을 충족하지 못하는 경우 약 일주일 후에 상장 폐지 알림을 받게 됩니다. 매주 월요일 플랫폼은 규정을 준수하지 않는 거래 쌍에 대해 상장 폐지 통지를 발행합니다. 이때 상장된 통화 사용자는 5일 이내에 연기된 상장 폐지를 신청할 수 있습니다. 지연 상장폐지 신청이 성공할 경우 4주간의 관찰시간을 추가로 부여하며, 그렇지 않을 경우 상장폐지됩니다.',
  8000163: '5. 상장자가 만든 거래 쌍의 사본이 플랫폼의 배당 기준을 충족하는 거래량을 달성하면 해당 거래 수수료 배당을 받게 됩니다.',
  8000164: '운영 활동 및 마케팅에 사용할 일정량의 토큰을 제공하여 코인의 영향력을 확대할 의향이 있으신가요?',
  8000165: '6. 상장 신청자는 플랫폼 고객 서비스에 문의하여 시장 제작자 자격을 신청할 수 있습니다.',
  8000166: '크리에이트',
  8000167: '거래 페어 복사본 {currency}을 생성하고 현물 메인보드 계정에서 {upFee} ET를 공제할 예정입니다.',
  8000168: '아니요',
  8000169: '네',
  8000170: '이메일 주소를 입력해주세요. 그러면 저희 마케팅 운영 팀이 연락을 드릴 것입니다',
  8000171: '추천인이나 연락할 분이 있나요?',
  8000172: '추천인 이름이나 연락처를 입력하세요.',
  8000173: '이 상자를 체크하면 모든 관련 위험을 감수하고 우리의 <a id="service_href" class="pointer" style="color: #D9A31A;text-decoration: underline" target="_self">약관 및 조건</a> 에 동의하는 것으로 간주됩니다.',
  8000174: '상장 수익을 얻다',
  8000175: '거래소에 상장하는 권리',
  8000176: '현재 이 통화는 상장 지원되지 않습니다!',
  8000177: '정보를 입력해주세요',
  8000178: '가서 공유해',
  8000179: '상장됨!',
  8000180: '자유 구역 상장, 부의 자유 시작',
  8000181: 'SuperEx에서 {symbol} 거래쌍을 만들었습니다! 달로 향해!',
  8000182: '매주 월요일에 각 배당금 지급 금액이 업데이트되지만 실제 지급 과정에서는 최대 3영업일이 지연될 수 있습니다. "지갑 기록" - "기타" - "메인 마켓" 아래에서 "보상 지급" 유형을 통해 관련 기록을 확인할 수 있습니다.',
  8000183: '트위터 계정',
  8000184: '텔레그램 계정',
  8000185: '디스코드 계정',
  8000186: '유효한 트위터 링크를 입력하세요!',
  8000187: '유효한 텔레그램 링크를 입력하세요!',
  8000188: '유효한 디스코드 링크를 입력하세요!',
  8000189: '트위터 링크를 입력해 주세요',
  8000190: '텔레그램 링크를 입력해 주세요',
  8000191: '디스코드 링크를 입력해 주세요',
  8000192: '죄송합니다. 해당 화폐의 스마트 계약 내용이나 관련 권한 설정에 높은 보안 위험이 있습니다. 다른 화폐를 시도해 주세요.',
  8000193: '죄송합니다. 해당 화폐의 스마트 계약 내용에 잠재적인 위험이 있습니다. 현재 상장을 할 수 없습니다. 다른 화폐를 시도해 주세요.',
  8000194: '주의 사항:',
  8000195: '이 암호화폐의 충전을 완료해야 판매 주문을 할 수 있습니다.',
  8000196: 'USDT를 자유 구역으로 이동한 후에야 구매 주문을 할 수 있습니다.',
  8000197: 'API를 연동한 후에야 시장 조성 거래를 할 수 있습니다.',
}
export default kr



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/kr.js